import React from 'react';
import {
  Box,
  Button,
  Icons,
  IconButton,
  Modal,
  Tooltip,
  Typography,
} from '@ublend-npm/aulaui-core';
import { createStyles } from './SubmissionActions.styles';

type Props = {
  deleting?: boolean;
  id: string;
  onClose: () => void;
  onConfirm: () => void;
  open: boolean;
  studentName: string;
};

const DeleteSubmissionModal = ({
  deleting = false,
  id,
  onClose,
  onConfirm,
  open,
  studentName,
}: Props) => {
  const styles = createStyles();
  const titleId = `${id}-title`;
  const descriptionId = `${id}-description`;

  return (
    <Modal
      aria-describedby={descriptionId}
      aria-labelledby={titleId}
      onClose={deleting ? undefined : onClose}
      open={open}
    >
      <Box onClick={(event) => event.stopPropagation()} sx={styles.modal}>
        <Box sx={styles.modalHeader}>
          <Typography component="h2" id={titleId} sx={styles.modalTitle}>
            Delete submission?
          </Typography>
          <Tooltip title="Close">
            <span>
              <IconButton
                aria-label="Close delete submission dialog"
                disabled={deleting}
                onClick={onClose}
                size="small"
                sx={styles.closeButton}
                type="button"
              >
                <Icons.Close />
              </IconButton>
            </span>
          </Tooltip>
        </Box>

        <Box id={descriptionId} sx={styles.modalBody}>
          <Typography sx={styles.message}>
            Are you sure you want to delete {studentName}&apos;s submission?
          </Typography>
          <Typography sx={styles.consequence}>
            The submission and all associated data will be permanently deleted.
            This action cannot be undone.
          </Typography>
        </Box>

        <Box sx={styles.modalFooter}>
          <Button
            disabled={deleting}
            kind="secondary"
            onClick={onClose}
            type="button"
          >
            Cancel
          </Button>
          <Button
            disabled={deleting}
            kind="primary"
            loading={deleting}
            onClick={onConfirm}
            sx={styles.deleteButton}
            type="button"
          >
            Delete Submission
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default DeleteSubmissionModal;
